import React from "react";
import { Box, CircularProgress, useTheme } from "@mui/material";
import ColoredIcon from "./ColoredIcon";
import DefaultIcon from "../img/default_icon.svg";

interface BrandAvatarProps {
    logo?: string | null;
    size?: number; // px, default: 40
    rounded?: boolean;
    loading?: boolean;
}

const BrandAvatar: React.FC<BrandAvatarProps> = ({
    logo,
    size = 40,
    rounded = true,
    loading = false,
}) => {
    const theme = useTheme();

    return (
        <Box
            width={size}
            height={size}
            borderRadius={rounded ? "50%" : "8px"}
            overflow="hidden"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgcolor={
                logo && !loading
                    ? "transparent"
                    : `${theme.palette.primary.main}`
            }
            sx={
                logo && !loading
                    ? {
                          backgroundImage: `url(${logo})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                      }
                    : undefined
            }
        >
            {loading ? (
                <CircularProgress size={size * 0.5} sx={{ color: "white" }} />
            ) : !logo ? (
                <ColoredIcon icon={DefaultIcon} size="75%" color="white" />
            ) : null}
        </Box>
    );
};

export default BrandAvatar;
